export const state = {
    orphanList: [],
    orphan: {},
    isInfoOpened: false,
    isLoading: false
};
